import _ from 'lodash';
import * as Cookies from 'js-cookie';

import {clientId, host, SSO_login} from '../utilities/requests';
import Pako from 'pako';


export const SET_MODE = 'MAIN_SET_MODE';
export const SET_PAGE_TYPE = 'MAIN_SET_PAGE_TYPE';
export const INCREMENT_PENDING = 'MAIN_INCREMENT_PENDING';
export const DECREMENT_PENDING = 'MAIN_DECREMENT_PENDING';
export const SET_USER = 'MAIN_SET_USER';
export const SET_APPLICATION = 'MAIN_SET_APPLICATION';
export const SET_DEFAULT_APPLICATION = 'MAIN_SET_DEFAULT_APPLICATION';
export const LOGGED_IN = 'MAIN_LOGGED_IN';
export const LOGGED_OUT = 'MAIN_LOGGED_OUT';
export const LOGIN_FAILED = 'MAIN_LOGIN_FAILED';
export const SET_UNREAD_MESSAGES = 'MAIN_SET_UNREAD_MESSAGES';
export const SET_COMPONENTS_INITIAL_STATE = 'MAIN_SET_COMPONENTS_INITIAL_STATE';
export const FETCH_INFORMATION = 'MAIN_FETCH_INFORMATION';

export const MODE_CONCENTRATE = 'MODE_CONCENTRATE';
export const PAGE_ADMIN = 'PAGE_ADMIN';
export const PAGE_NORMAL = 'PAGE_NORMAL';

export function incrementPending() {
    return {
        type: INCREMENT_PENDING,
    };
}

export function decrementPending() {
    return {
        type: DECREMENT_PENDING,
    };
}

export function setMode(mode) {
    return {
        type: SET_MODE,
        mode,
    };
}

export function enterAdminPage() {
    return {
        type: SET_PAGE_TYPE,
        payload: PAGE_ADMIN,
    };
}

export function enterNormalPage() {
    return {
        type: SET_PAGE_TYPE,
        payload: PAGE_NORMAL,
    };
}

export function resetMode() {
    return {
        type: SET_MODE,
        mode: undefined,
    };
}

export function login(username, password) { // using oath2
    return async dispatch => {
        dispatch(incrementPending());
        const payload = {
            grant_type: 'password',
            username,
            password,
            client_id: clientId,//Cookies.get('mhelli_web_client_id')
        };
        const init = {
            method: 'POST',
            body: JSON.stringify(payload),
            headers: {
                'content-type': 'application/json',
            },
        };
        const request = new Request(host + '/o/token/', init);
        try {
            const response = await fetch(request);
            const json = toCamel(await response.json());
            if (json.accessToken) {
                dispatch([
                    decrementPending(),
                    loggedIn(json),
                ]);
                return json;
            }
            else {
                throw json;
            }
        }
        catch (error) {
            dispatch(decrementPending());
            dispatch(loginFailed(error));
            throw error;
        }
    };
}

export function refreshToken () {
    console.log('refreshing');
    return async (dispatch, getState) => {
        const refreshToken = getState().getIn(['application', 'token', 'refreshToken']);
        if (!refreshToken) {
            dispatch(logout());
            throw new Error('Refresh token not available.');
        }
        dispatch(incrementPending());
        const payload = SSO_login ? 
            {
                refresh_token: refreshToken,
            }
        :
            {
                grant_type: 'refresh_token',
                refresh_token: refreshToken,
                client_id: clientId,//Cookies.get('mhelli_web_client_id'),
            };
        const init = {
            method: 'POST',
            body: JSON.stringify(payload),
            headers: {
                'content-type': 'application/json',
            },
        };
        const authEndpoint = SSO_login ? '/api/sso/refresh_token/' : '/o/token/';
        const request = new Request(host + authEndpoint, init);
        const response = await fetch(request);
        const json = toCamel(await response.json());
        dispatch(decrementPending());
        if (json.accessToken) {
            dispatch(loggedIn(json, {refreshed: true}));
            return true;
        }
        else {
            if (getState().getIn(['application', 'token', 'refreshToken']) !== refreshToken) {
                return true;
            }
            else {
                dispatch(logout());
                return false;
            }
        }
    };
}

var freeToCallNextAPI=true ;

/**pass -1 as "saveCacheForThisMuchSeconds" to make this function descide about the cache time */
export function request(path, initial, saveCacheForThisMuchSeconds=-1,onSubmited=null,onError=null,callOutOfQue=false,ignoreCache=false) {
    const _request = request;
    if (path instanceof Object) {
        initial = path;
        path = initial.path;
    }
    else if (initial === undefined) {
        initial = {};
    }
    return async (dispatch, getState) => {
        // console.log('*** path called : '+path);
        const token = getState().getIn(['application', 'token']);

        initial.method = initial.method || (initial.body ? 'POST' : 'GET');
        let isJson = false, isZipped = false;
        var rawRequestBody = '';
        var storedMethod = initial.method ;
        var currentToken = token==null || typeof(token.getIn) !== 'function' ?'':token.getIn(['accessToken']) ;
        if (_.isPlainObject(initial.body) || _.isArray(initial.body)) {
            initial.body = JSON.stringify(initial.body);
            rawRequestBody = initial.body ;//For cache
            isJson = true;
        }
        // if (process.env.NODE_ENV === 'production' && !initial?.gzip) {//May remove this clientside encryption
        //     if (_.isString(initial.body)) {
        //         initial.body = new Blob([Pako.gzip(initial.body)], {type: 'application/json'});
        //         isZipped = true;
        //     }
        // }
        const request = path.indexOf('http')===0 ? new Request(path, initial) : new Request(host + '/api' + path, initial);
        if (isJson)
            request.headers.set('Content-Type', 'application/json');
        if (isZipped) {
            request.headers.set('Content-Encoding', 'gzip');
            request.headers.set('Content-Length', initial.body.size);
        }
        if (token && currentToken) {
            request.headers.set(
                'Authorization',
                `${token.get('tokenType')} ${currentToken}`,
            );
        }

        saveCacheForThisMuchSeconds = saveCacheForThisMuchSeconds==-1?timeToCahce(path):saveCacheForThisMuchSeconds;
        
        dispatch(incrementPending());


        if(freeToCallNextAPI===false && !callOutOfQue)
        {
            await new Promise((resultFunc)=>{
                let myIntervalId = setInterval(()=>{
                    if(freeToCallNextAPI)
                    {
                        clearInterval(myIntervalId);
                        resultFunc();
                    }
                },200)
            });
        }
        else
        {
            freeToCallNextAPI = false ;
            await new Promise((resultFunc)=>{setTimeout(()=>{resultFunc();},1)});
        }


        var cachedData = ignoreCache==true && (window.location.host.indexOf('localho22222st') != -1) ? getLocalStorageData(path,currentToken,rawRequestBody,saveCacheForThisMuchSeconds,storedMethod) : null ;
        if(cachedData!=null)
        {
            freeToCallNextAPI = true ;
            dispatch(decrementPending());
            if(onSubmited!==null)onSubmited();
            return cachedData;
        }

        let response;
        let json;

        try {
            response = await fetch(request);
            freeToCallNextAPI = true ;
            // if(path == "/user/me/" && response.status == 401){
            //     logout()
            // }
            try {
                json = await response.json();
                if (response.status === 403)
                {
                    if(onError!==null)
                        onError(json.detail);
                    else
                        alert(json.detail);
                    return;
                }
                    
            }
            catch (exception) {
                if (!response.ok)
                    throw exception;
                json = null;
            }
            if (
                response.status === 401 
                &&
                // json.detail ===
                // 'Authentication credentials were not provided.' &&
                getState().getIn(['application', 'token']

                )
            ) {
                if (await dispatch(refreshToken())) {
                    const result = await dispatch(_request(path,initial,saveCacheForThisMuchSeconds,onSubmited,onError,true));
                    dispatch(decrementPending());
                    return result;
                }
            }
        }
        catch (error) {
            freeToCallNextAPI = true ;
            dispatch(decrementPending());
            if(onError!==null)onError();
            throw error;
        }
        dispatch(decrementPending());
        if (response.ok) {

            clearCacheIfShould(path,rawRequestBody,initial.method);
            saveLocalStorage(path,currentToken,rawRequestBody,json,initial.method,saveCacheForThisMuchSeconds);

            if(onSubmited!==null)onSubmited(json);

            return json;
        }
        else {
            if(onError!==null)onError();
            throw json;
        }
    };
}

/**
 * Authenticated request for long-running/background UI workflows.
 *
 * Unlike request(), this helper deliberately does not participate in the
 * application-wide pending counter or the legacy single-request queue.  It is
 * intended for status polling and fast queue-submission endpoints, where a
 * global loading state would otherwise make unrelated pages feel blocked.
 */
export function backgroundRequest(path, initial={}) {
    return async (dispatch, getState) => {
        const perform = async () => {
            const token = getState().getIn(['application', 'token']);
            const requestInit = {...initial};
            requestInit.method = requestInit.method || (requestInit.body ? 'POST' : 'GET');
            const target = path.indexOf('http') === 0 ? path : host + '/api' + path;
            const apiRequest = new Request(target, requestInit);
            if (_.isPlainObject(requestInit.body) || _.isArray(requestInit.body)) {
                apiRequest.headers.set('Content-Type', 'application/json');
            }
            if (token && typeof token.getIn === 'function' && token.getIn(['accessToken'])) {
                apiRequest.headers.set(
                    'Authorization',
                    `${token.get('tokenType')} ${token.getIn(['accessToken'])}`,
                );
            }
            return fetch(apiRequest);
        };

        let response = await perform();
        if (response.status === 401 && getState().getIn(['application', 'token'])) {
            if (await dispatch(refreshToken()))
                response = await perform();
        }

        let json = null;
        try {
            json = await response.json();
        }
        catch (exception) {
            if (!response.ok)
                throw exception;
        }
        if (!response.ok)
            throw json || {detail: `HTTP ${response.status}`};
        return json;
    };
}

//Local cache
function clearCacheIfShould(path='',rawRequestBody='',method='')
{
    if(!shouldStoreOffline(path,rawRequestBody,method,Infinity) && method!=='GET')
    {
        clearAllCache(path.indexOf('content') != -1);
    }
}

function timeToCahce(path='')
{
    if(path.indexOf('content')>0 ||
        path.indexOf('user/menu')>0
    )
        return 2*60*60;
        
    //examination
    return 5*60;
}

function shouldStoreOffline(path='',body='',method='',saveCacheForThisMuchSeconds=0)
{
    return saveCacheForThisMuchSeconds!=0
     && path.indexOf("www.raychat.io")==-1 && path.indexOf("rayToken")==-1 
    //  && path.indexOf("question-label")
     && (
         method === 'GET' 
         || path.indexOf('get/')!=-1
        );
}


function clearAllCache(removeContents=false)
{ 
    // console.log('clear cache : '+removeContents);
    var skipedIndex = 0 ;
    while(localStorage.length>skipedIndex)  
    {  
        var key = localStorage.key(skipedIndex);
        
        if(key.indexOf('CACHE')!==0
            ||
            (
                !removeContents
                &&
                (
                    key.indexOf('/content/') != -1
                    ||
                    key.indexOf('menu/') != -1
                )
            )
        )
        {
            // console.log("Skip cache remove for "+key);
            skipedIndex++ ;
            continue;
        }
        // console.log("remove "+key);
        localStorage.removeItem(key);  
    }  
}


    function getLocalStorageData(path='',token='',body='',saveCacheForThisMuchSeconds=0,storedMethod='POST')
    {
        if(!shouldStoreOffline(path,body,storedMethod,saveCacheForThisMuchSeconds))return null;
        var loadedData = localStorage.getItem(createStorageId(path,token,body));
        if(loadedData==null)return null;
        return stringToStorageObjec(loadedData,saveCacheForThisMuchSeconds);

    }

    function saveLocalStorage(path='www',token='bariear',body='',respondjson={},method="GET",saveCacheForThisMuchSeconds=0)
    {
        if(!shouldStoreOffline(path,body,method,saveCacheForThisMuchSeconds))return;
        try{
            localStorage.setItem(createStorageId(path,token,body),storageObjectToString(respondjson));
        }
        catch(e)
        {
            console.log(e);
        }
    }

        function stringToStorageObjec(stringInput='',saveCacheForThisMuchSeconds=0)
        {
            if(stringInput==null || stringInput=='')return null;
            
            try
            {
                var data = JSON.parse(stringInput);


                if(data!=null && data.data != undefined && data.time>new Date().getTime()-saveCacheForThisMuchSeconds*1000)
                    return data.data ;
                else
                    return null ;
            }
            catch(e)
            {
                return null ;
            }
        }

        function storageObjectToString(respondJSON={})
        {
            var data = {
                data : respondJSON,
                time : new Date().getTime()
            }
            return JSON.stringify(data);
        }

        function createStorageId(path='',token='',body='')
        {
            token = token!=null?token.substring(10):'';
            body = body==null?'':body;
            return 'CACHE'+(path+token+body).replace(/[\?\&\s\t:]/gi,'')
        }

///////////////////////

export function fetchUser() {
    return async dispatch => {
        const response = await dispatch(request('/user/me/'));
        if (response.error) {
            await dispatch(logout());
            return false;
        }
        else {
            await dispatch([
                setUser(response),
                setUnreadMessages(response.unread_messages),
            ]);
            return true;
        }
    };
}

export function fetchInformation() {
    return {
        type: FETCH_INFORMATION,
    };
}

export function setUser(user) {
    return {
        type: SET_USER,
        payload: user,
    };
}

export function setApplication(application) {
    return {
        type: SET_APPLICATION,
        payload: application,
    };
}

export function setDefaultApplication(application) {
    return {
        type: SET_DEFAULT_APPLICATION,
        payload: application,
    };
}

export function loggedIn(token, options={}) {
    Cookies.set('mhelli-token', token, {expires: 30});
    return [
        {
            type: LOGGED_IN,
            token,
        },
        ...options.refreshed ? [] : [],
    ];
}
export function loginFailed(error) {
    return dispatch => {
        dispatch({
            type: LOGIN_FAILED,
            error,
        });
    };
}

export function logout() {
    Cookies.set('mhelli-token', {}, {expires: 30});
    window.location.replace('/');
    return {
        type: LOGGED_OUT,
    };
}

export function setUnreadMessages(count) {
    return {
        type: SET_UNREAD_MESSAGES,
        payload: count,
    };
}

export function setComponentInitialState(component, instanceId, state) {
    return {
        type: SET_COMPONENTS_INITIAL_STATE,
        component,
        instanceId,
        state,
    };
}

function toCamel(o) {
    if (o instanceof Array) {
        const build = [];
        for (let key in o) {
            let value = o[key];

            if (typeof value === 'object') {
                value = toCamel(value);
            }
            build.push(value);
        }
        return build;
    }
    else {
        const build = {};
        for (let key in o) {
            if (o.hasOwnProperty(key)) {
                const destKey = _.camelCase(key);
                let value = o[key];
                if (value !== null && typeof value === 'object') {
                    value = toCamel(value);
                }

                build[destKey] = value;
            }
        }
        return build;
    }
}
export function loginSSO(state, code, userName){
    return async dispatch => {
        dispatch(incrementPending());
        const payload = {
            state: state,
            code: code,
            username: userName
        };
        const init = {
            method: 'POST',
            body: JSON.stringify(payload),
            credentials : 'include',
            headers: {
                'content-type': 'application/json',
            },
        };
        const request = new Request(host + '/api/sso/login/', init) 
        try {
            const response = await fetch(request);
            const json = toCamel(await response.json());
            if (json.accessToken) {
                dispatch([
                    decrementPending(),
                    loggedIn(json),
                ]);
                return json;
            }
            else {
                throw json;
            }
        }
        catch (error) {
            dispatch(decrementPending());
            dispatch(loginFailed(error));
            throw error;
        }
    };
}
